module.exports = __webpack_public_path__ + "img/mandandoBeijo.392de433.png";